import React from 'react';
import './BottomComponent.css';
import '../../App.css'
import {Box, Button, Flex, Image, Link, Stack} from "@chakra-ui/react";

import appleLogo from '../../images/apple_store.png'
import googleLogo from '../../images/google_play_store.png'
import {Animated} from "react-animated-css";
import {useTranslation} from "react-i18next";

const BottomComponent = () => {
    const [t, i18n] = useTranslation('common');
    return (
        <Flex className="tab-bottom-component">

            <Animated animationIn="fadeIn"
                      animationOut="fadeOut"
                      isVisible={true}
                      animationInDuration={4000}>
                <Flex flexDirection="column" marginTop="80px" marginBottom="140px">
                    <Box className="body-description-small">
                        {t("Start now")}
                    </Box>

                    <Stack direction="row"
                           spacing="12px"
                           textColor="black"
                           justifyContent="center"
                           marginTop="40px">
                        <Link>
                            <Button
                                leftIcon={<Image
                                    src={appleLogo}
                                    alt="new"
                                    height="20px"
                                    width="20px"
                                    objectFit="contain"/>}
                                fontSize="14px"
                                minHeight="52px"
                                paddingRight="22px"
                                fontWeight="500"
                                borderRadius="36px">
                                {t("App store").toUpperCase()}
                            </Button>
                        </Link>
                        <Link >
                            <Button
                                leftIcon={<Image
                                    src={googleLogo}
                                    alt="new"
                                    height="20px"
                                    width="20px"
                                    objectFit="contain"/>}
                                fontSize="14px"
                                fontWeight="500"
                                minHeight="52px"
                                paddingRight="22px"
                                borderRadius="36px">
                                {t("Google play").toUpperCase()}
                            </Button>
                        </Link>
                    </Stack>
                    <Box marginTop="12px">
                        <span className="body-content-extra-small-transparent">{t("Basic membership is free")}</span>
                    </Box>
                </Flex>
            </Animated>


        </Flex>
    )

}
export default BottomComponent